import { generateFGLTicket, generateFGLTicketUSB, generateFGLFlexpass, generateFGLFlexpassUSB, generateFGLCoupon, generateFGLCouponUSB } from './templates';
import QRCode from 'qrcode';
import { isWindows } from 'react-device-detect';

export default class Star {
    constructor() {
        this.state = {
            starPrinters: null,
            JSPM_WS_Status: null
        }
    };

    getStarPrinters2 = () => {
        // script 1
        return new Promise((resolve, reject) => {
            this.startPrinterOrRejectPromise(resolve, reject);
        });
    };

    jspmWsStatusChanged = (status) => {
        console.log("jspmWsStatusChanged:", status);
        this.state.JSPM_WS_Status = status;
    };

    jspmWsUpdateStatus = () => {
        this.jspmWsStatusChanged(
            window.JSPM.WSStatus[window.JSPM.JSPrintManager.WS.status]
        );
    };

    startPrinterOrRejectPromise = (resolve, reject) => {
        //WebSocket settings
        /* window.JSPM.JSPrintManager.license_url = `${process.env.REACT_APP_SITE_URL}/api/jspm`;
        window.JSPM.JSPrintManager.auto_reconnect = true;
        window.JSPM.JSPrintManager.start(); */
        // binds this class to : window.JSPM.JSPrintManager.MainApp (keep for debug)
        window.JSPM.JSPrintManager.MainApp = this;

        // status change
        window.JSPM.JSPrintManager.WS.onStatusChanged = (() => {
            // update status first
            this.jspmWsUpdateStatus();

            // then get the printers list - if JSPM is running
            if (this.jspmWSStatus()) {
                console.log('STAR window.JSPM.JSPrintManager.getPrintersInfo()', window.JSPM.JSPrintManager.getPrintersInfo())
                window.JSPM.JSPrintManager.getPrintersInfo().then(((printersList) => {
                    console.log('STAR printersList', printersList)
                    this.state.starPrinters = printersList.filter((printer) => printer.name.includes('Star'));
                    resolve(this.state.starPrinters);
                }));
            } else {
                reject(false);
            }
        });

        // Status event : onOpen
        window.JSPM.JSPrintManager.WS.onOpen = (() => {
            this.jspmWsUpdateStatus();
            window.JSPM.JSPrintManager.getPrintersInfo().then(((printersList) => {
                console.log('printersList', printersList)
                this.state.starPrinters = printersList.filter((printer) => printer.name.includes('Star'));
                resolve(this.state.starPrinters);
            }));
        });

        // Status event : onClose
        window.JSPM.JSPrintManager.WS.onClose = (() => {
            this.jspmWsUpdateStatus();
        });
    };

    //Check JSPM WebSocket status
    jspmWSStatus = () => {
        if (window.JSPM.JSPrintManager.websocket_status == window.JSPM.WSStatus.Open) {
            console.log('JSPM is running');
            return true;
        }
        else if (window.JSPM.JSPrintManager.websocket_status == window.JSPM.WSStatus.Closed) {
            console.log('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
            return false;
        }
        else if (window.JSPM.JSPrintManager.websocket_status == window.JSPM.WSStatus.BlackListed) {
            console.log('JSPM has blacklisted this website!');
            return false;
        }
    };

    initStarPrinters = (manager) => {
        manager.onReceive = (response) => {
            if (response.managerSuccess == 'true' && response.managerClaim == 'true') {
                console.log('Star printer connected');
            }
            else if (response.managerClaim == 'true') {
                // Keep Connecting
            }
            else {
                console.log('Star printer NOT connected');
            }
    
            let msg = 'onReceive {\n';
            msg += '\tManagerSuccess : [ ' + response.managerSuccess + ' ]\n';
            msg += '\tManagerCode : [ '    + response.managerCode    + ' ]\n }';
            console.log(msg);
        }
    
        manager.onError = (args) => {
            let msg = 'onError {\n';
            msg += '\tStatus: '      + args.status       + '\n';
            msg += '\tResponseText:' + args.responseText + '\n }';
            console.log(msg);
        }
    
        manager.onAccessoryDisconnect = () => {
            console.log('star printer event : onAccessoryDisconnect');
        }
        manager.onAccessoryConnectSuccess = () => {
            console.log('star printer event : onAccessoryConnectSuccess');
        }
        manager.onAccessoryConnectFailure = () => {
            console.log('star printer event : onAccessoryConnectFailure');
        }
        manager.onPrinterImpossible = () => {
            console.log('star printer event : onPrinterImpossible');
        }
        manager.onPrinterOnline = () => {
            console.log('star printer event : onPrinterOnline');
        }
        manager.onPrinterOffline = () => {
            console.log('star printer event : onPrinterOffline');
        }
        manager.onPrinterPaperReady = () => {
            console.log('star printer event : onPrinterPaperReady');
        }
        manager.onPrinterPaperNearEmpty = () => {
            console.log('event : onPrinterPaperNearEmpty');
        }
        manager.onPrinterPaperEmpty = () => {
            console.log('star printer event : onPrinterPaperEmpty');
        }
        manager.onPrinterCoverOpen = () => {
            console.log('star printer event : onPrinterCoverOpen');
        }
        manager.onPrinterCoverClose = () => {
            console.log('star printer event : onPrinterCoverClose');
        }
        manager.onCashDrawerOpen = () => {
            console.log('star printer event : onCashDrawerOpen');
        }
        manager.onCashDrawerClose = () => {
            console.log('star printer event : onCashDrawerClose');
        }
        manager.onDisplayImpossible = () => {
            console.log('star printer event : onDisplayImpossible');
        }
        manager.onDisplayConnect = () => {
            console.log('star printer event : onDisplayConnect');
        }
        manager.onDisplayDisconnect = () => {
            console.log('star printer event : onDisplayDisconnect');
        }
        manager.onWrite = () => {
            console.log('star printer event : onWrite');
        }
        manager.onStatusUpdate = () => {
            console.log('star printer event : onStatusUpdate');
        }
    }

    getStarPrinters = () => {
        let manager = new window.StarWebPrintExtManager();
        this.initStarPrinters(manager);
        if (manager.connect({url:`${localStorage.getItem("defaultStarPrinter")}/StarWebPRNT/SendDisplayExtMessage`}) == false) {        
            console.log('Already connected or Now communicating');
        }
        return [];
    }

    //Do printing...
    printFGLUSB = async (printer, labelType, labels, client, customer) => {
        console.log('printFGLUSB')
        if (this.jspmWSStatus()) {
            console.log('jspmWSStatus')
            let cpj = new window.JSPM.ClientPrintJob();
            console.log('isWindows', isWindows);
            let paper = isWindows ? '48mm x Receipt' : '48mm * 200mm';
            cpj.clientPrinter = new window.JSPM.InstalledPrinter(printer, false, '', paper);
            
            for (let i = 0; i < labels.length; i++) {
                let label = labels[i];
                let labelFGL = '';

                switch (labelType) {
                    case 'ticket':
                        labelFGL = await generateFGLTicketUSB(label, client, customer);
                        break;
                    case 'flexpass':
                        labelFGL = await generateFGLFlexpassUSB(label, client);
                        break;
                    case 'coupon':
                        labelFGL = await generateFGLCouponUSB(label, client);
                        break;
                    default:
                        labelFGL = await generateFGLTicketUSB(label, client, customer);
                }
                console.log('labelFGL', labelFGL);
                let myTxtFile = new window.JSPM.PrintFileTXT(labelFGL, `myFileToPrint-${i}.txt`, 1);
                myTxtFile.fontSize = parseFloat(8);

                // Create QR Code to canvas, then convert canvas URI to PNG
                let QRCodeUrl = `${label.id}`;
                //console.log('QRCodeUrl', QRCodeUrl);
                if (label.event) {
                    if (label.event.event_type === 'Live Stream' || label.event.event_type === 'Scheduled Content' || label.event.event_type === 'Video On Demand') {
                        QRCodeUrl = `https://www.showtix4u.com/stream/${label.activation_code}`;
                        //console.log('QRCodeUrl', QRCodeUrl);
                    }
                }
                console.log('QRCodeUrl', QRCodeUrl);
                
                QRCode.toCanvas(document.getElementById('canvas'), QRCodeUrl,
                    (error) => {
                        console.log(error);
                    },
                    (success) => {
                        console.log('success!');
                        window.html2canvas(document.getElementById('canvas'), { scale: 5 }).then((canvas) => {
                            console.log('canvas', canvas);
                            var b64Prefix = "data:image/png;base64,";
                            //console.log('b64Prefix', b64Prefix);
                            var imgBase64DataUri = canvas.toDataURL("image/png");
                            //console.log('imgBase64DataUri', imgBase64DataUri);
                            var imgBase64Content = imgBase64DataUri.substring(b64Prefix.length, imgBase64DataUri.length);
                            //console.log('imgBase64Content', imgBase64Content);
                            var myImageFile = new window.JSPM.PrintFile(imgBase64Content, window.JSPM.FileSourceType.Base64, `myImageToPrint-${i}.png`, 1);
                            console.log('myImageFile', myImageFile);
                            console.log('cpj.files', cpj.files);
                            //add file to print job
                            cpj.files.push(myTxtFile);
                            cpj.files.push(myImageFile);
                        });
                    }
                );
            }

            setTimeout(() => {
                console.log('sendToClient');
                cpj.sendToClient();
            }, 4000);
        }
    };

    insertScriptTag = (url, callback) => {
        let aScript = document.createElement('script');
        aScript.type = 'text/javascript';
        aScript.src = url;
        document.head.appendChild(aScript);
        aScript.onload = function() {
            console.log("Script loaded:", url);
            if(callback) callback();
        };
    };
    
    //Do printing...
    printFGL = async (labelType, labels, client, customer) => {
        let builder = new window.StarWebPrintBuilder();
        let trader = new window.StarWebPrintTrader({url:`${localStorage.getItem('defaultStarPrinter')}/StarWebPRNT/SendMessage`, papertype:'normal', checkedblock: true});
        let request = '';

        for (let i = 0; i < labels.length; i++) {
            let label = labels[i];
            let labelFGL = '';

            switch (labelType) {
                case 'ticket':
                    labelFGL = await generateFGLTicket(label, client, customer, builder);
                    break;
                case 'flexpass':
                    labelFGL = await generateFGLFlexpass(label, client, builder);
                    break;
                case 'coupon':
                    labelFGL = await generateFGLCoupon(label, client, builder);
                    break;
                default:
                    labelFGL = await generateFGLTicket(label, client, customer, builder);
            }

            console.log("labelFGL", labelFGL);

            /* if (isBluetooth) {
                let tab = window.open();
                setTimeout(() => {
                    tab.document.title = 'Your ticket';
                    tab.document.close();
                    tab.focus();
                    tab.print();
                }, 200);
                tab.document.write(labelFGL);
            } else {
                console.log("labelFGL", labelFGL); */
                request += labelFGL;
            //}
        }
        
        trader.onReceive = (response) => {
            let msg = '- onReceive -\n\n';
            msg += 'TraderSuccess : [ ' + response.traderSuccess + ' ]\n';
            msg += 'TraderCode : [ ' + response.traderCode + ' ]\n';
            msg += 'TraderStatus : [ ' + response.traderStatus + ',\n';

            if (trader.isCoverOpen            ({traderStatus:response.traderStatus})) {msg += '\tCoverOpen,\n';}
            if (trader.isOffLine              ({traderStatus:response.traderStatus})) {msg += '\tOffLine,\n';}
            if (trader.isCompulsionSwitchClose({traderStatus:response.traderStatus})) {msg += '\tCompulsionSwitchClose,\n';}
            if (trader.isEtbCommandExecute    ({traderStatus:response.traderStatus})) {msg += '\tEtbCommandExecute,\n';}
            if (trader.isHighTemperatureStop  ({traderStatus:response.traderStatus})) {msg += '\tHighTemperatureStop,\n';}
            if (trader.isNonRecoverableError  ({traderStatus:response.traderStatus})) {msg += '\tNonRecoverableError,\n';}
            if (trader.isAutoCutterError      ({traderStatus:response.traderStatus})) {msg += '\tAutoCutterError,\n';}
            if (trader.isBlackMarkError       ({traderStatus:response.traderStatus})) {msg += '\tBlackMarkError,\n';}
            if (trader.isPaperEnd             ({traderStatus:response.traderStatus})) {msg += '\tPaperEnd,\n';}
            if (trader.isPaperNearEnd         ({traderStatus:response.traderStatus})) {msg += '\tPaperNearEnd,\n';}
            if (trader.isPaperPresent         ({traderStatus:response.traderStatus})) {msg += '\tPaperPresent,\n';}

            msg += '\tEtbCounter = ' + trader.extractionEtbCounter({traderStatus:response.traderStatus}).toString() + ' ]\n';
            msg += 'Status : [ ' + response.status + ' ]\n';
            msg += 'ResponseText : [ ' + response.responseText + ' ]\n';
            console.log(msg);
        }

        trader.onError = (response) => {
            let msg = '- onError -\n\n';
            msg += '\tStatus:' + response.status + '\n';
            msg += '\tResponseText:' + response.responseText + '\n\n';
            console.log(msg);
            //alert('onError');
            trader.sendMessage({request:request});
        }

        console.log('request', request)
        /* if (isBluetooth) {
            let html = "Print your ticket";
            html += request;
            let tab = window.open();
            tab.document.write(html);
        } */
        //if (request !== '' && !isBluetooth) {
        if (request !== '') {
            trader.sendMessage({request:request});
        }
    };
}

if (typeof module !== 'undefined' && module.exports) {
    module.exports = Star;
} else {
    window.Star = Star;
}



// WEBPACK FOOTER //
// ./src/lib/labels/star/index.js